import dynamic from "next/dynamic";
import CardFormStripe from "@/components/common/stripe/CardFormStripe";
import { getPaymentMethods } from "@/store/user/selectors-user";
import { useStore } from "@/store/index";
import { MDBCol, MDBRow } from "mdb-react-ui-kit";
import React, { Reducer, useReducer, useState } from "react";
import styles from "@/styles/userPage/PaymentsSection.module.scss";
import CreditCard from "@/components/common/CreditCard";
import Btn from "@/components/common/Btn";
import DeleteCardModalBody from "@/components/account/userPage/DeleteCardModalBody";
import {
    subTitleDeteleteCard,
    titleDeteleteCard,
} from "@/utils/mockData/userMocks";
import Coupon from "./Coupon";

interface DeleteModalState {
    show: boolean;
    token: string;
}

const CustomModal = dynamic(() => import("@/common/CustomModal"), {
    ssr: false,
});

const PaymentsMethodSection = () => {
    const [deleteModalState, setDeleteModalState] = useReducer<
        Reducer<DeleteModalState, Partial<DeleteModalState>>
    >((state, newState) => ({ ...state, ...newState }), {
        show: false,
        token: "",
    });

    const paymentMethods = useStore(getPaymentMethods);

    const [openForm, setOpenForm] = useState(false);

    const setShowDeleteModal = (show: boolean) =>
        show
            ? setDeleteModalState({ show: true })
            : setDeleteModalState({ show: false, token: "" });

    const { show: showDeleteModal } = deleteModalState;

    return (
        <div className="pl-sm-2">
            <MDBRow>
                <MDBCol size={12}>
                    <p className={styles.title}>Credit card</p>
                </MDBCol>

                <MDBRow>
                    <MDBCol size={12} xl={8}>
                        {paymentMethods?.map(curr => (
                            <CreditCard
                                creditCardData={curr}
                                onClickDelete={id =>
                                    setDeleteModalState({
                                        show: true,
                                        token: id,
                                    })
                                }
                            />
                        ))}
                    </MDBCol>
                    <MDBCol size={12} xl={4} className="mb-4 mb-md-0">
                        <Btn
                            className={styles.buttonAddCart}
                            onClick={() => setOpenForm(!openForm)}
                        >
                            Add payment method
                        </Btn>
                    </MDBCol>
                </MDBRow>

                {openForm && (
                    <CardFormStripe
                        onSuccessSaveCard={() => setOpenForm(false)}
                    />
                )}
            </MDBRow>
            <div className={styles.containerCoupon} style={{ display: "none" }}>
                <Coupon />
            </div>
            {showDeleteModal && (
                <CustomModal
                    displayModal={showDeleteModal}
                    setShow={setShowDeleteModal}
                    sectionTitle={{
                        title: titleDeteleteCard,
                        subTitle: subTitleDeteleteCard,
                    }}
                    staticBackdrop
                >
                    <DeleteCardModalBody
                        cardToken={deleteModalState.token}
                        onSuccess={() => setShowDeleteModal(false)}
                    />
                </CustomModal>
            )}
            <Coupon />
        </div>
    );
};

export default PaymentsMethodSection;
